import { Component, OnInit } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { first } from 'rxjs/operators';

import { GiftTicketDownloadService } from '../services/gift-ticket-download.service';

import { CartItemOptions, CartItemTypes } from '@api/cart/cart.models';
import { Item } from '@api/catalog/items/medias/items.models';
import { DialogRef } from '@ui/dialog/dialog-ref';

@Component({
    selector: 'gift-ticket-download',
    templateUrl: './gift-ticket-download.component.html',
})
export class GiftTicketDownloadComponent implements OnInit {
    public itemType: CartItemOptions = { name: CartItemTypes.ITEM_GIFT_TICKET };

    private readonly orderId: number = this.modalRef.data.order.id;

    public items: Item[] = this.modalRef.data.items;

    public selectedItems: Record<Item['id'], boolean> = {};

    public itemQuantities: Record<Item['id'], number> = {};

    public selectedItemsLength: number = 0;

    private readonly _selectedItemsLength$: BehaviorSubject<number> = new BehaviorSubject(0);

    public selectedItemsLength$: Observable<number> = this._selectedItemsLength$.asObservable();

    constructor(
        private readonly modalRef: DialogRef,
        private readonly giftTicketDownloadService: GiftTicketDownloadService
    ) {}

    public ngOnInit(): void {
        for (let item of this.items) {
            this.selectedItems[item.id] = false;
        }
    }

    public toggle(checked: boolean, id: Item['id']): void {
        if (checked) {
            this.selectedItemsLength += 1;
        } else {
            this.selectedItemsLength -= 1;
        }
        this._selectedItemsLength$.next(this.selectedItemsLength);
        this.selectedItems[id] = checked;
    }

    public selectQuantity({ item, quantity }: { item: Item; quantity: string }) {
        this.itemQuantities[item.id] = Number(quantity);
    }

    public download(): void {
        this.giftTicketDownloadService.download(this.orderId, this.items, this.selectedItems, this.itemQuantities).pipe(
            first()
        ).subscribe(() => {
            this.modalRef.close();
        });
    }
}
